import React, { useState } from "react";
import axios from "axios";
import "../css/ForgotId.css"; // 스타일 적용

const ForgotId = () => {
  const [phoneNumber, setPhoneNumber] = useState(""); // 사용자 입력 전화번호
  const [verificationCode, setVerificationCode] = useState(""); // 사용자 입력 인증번호
  const [resultMessage, setResultMessage] = useState(""); // 결과 메시지
  const [error, setError] = useState(null); // 에러 메시지
  const [codeSent, setCodeSent] = useState(false); // 인증번호 전송 여부
  const [codeVerified, setCodeVerified] = useState(false); // 인증번호 확인 여부
  const [showModal, setShowModal] = useState(false); // 모달 창 표시 여부

  // 전화번호로 인증번호 전송
  const sendVerificationCode = async () => {
    try {
      const response = await axios.post(
        "http://35.192.131.111/user/send/code/",
        {
          phone_number: phoneNumber,
        }
      );

      if (response.data.result) {
        setCodeSent(true);
        setError(null);
        alert("인증번호가 전송되었습니다.");
      } else {
        setError("인증번호 전송에 실패했습니다.");
      }
    } catch (error) {
      setError("인증번호 전송에 실패했습니다.");
    }
  };

  // 인증번호 확인
  const verifyCode = async () => {
    try {
      const response = await axios.post(
        "http://35.192.131.111/user/verify/code/",
        {
          phone_number: phoneNumber,
          verification_code: Number(verificationCode), // 인증번호를 숫자로 변환하여 전송
        }
      );

      if (response.data.result) {
        setCodeVerified(true);
        setError(null);
        alert("인증이 완료되었습니다.");
      } else {
        setError("인증번호가 올바르지 않습니다.");
      }
    } catch (error) {
      setError("인증번호 확인에 실패했습니다.");
    }
  };

  // 아이디 찾기 요청
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!codeVerified) {
      setError("먼저 인증번호 확인을 완료해주세요.");
      return;
    }

    try {
      const response = await axios.post(
        "http://35.192.131.111/user/username/",
        {
          phone_number: phoneNumber,
        }
      );

      if (response.data.result) {
        setResultMessage(`아이디는 ${response.data.username}입니다.`);
        setError(null);
        setShowModal(true); // 모달 창 열기
      } else {
        setResultMessage(response.data.message);
      }
    } catch (error) {
      setError("아이디 찾기에 실패했습니다.");
    }
  };

  // 모달 창 닫기 함수
  const closeModal = () => {
    setShowModal(false);
    setResultMessage("");
  };

  return (
    <div className="forgotId-Main">
      <div className="forgotId-container">
        <h2>아이디 찾기</h2>

        {error && <p className="error-message">{error}</p>}

        <form className="forgotId-form" onSubmit={handleSubmit}>
          {/* 전화번호 입력 */}
          <div className="form-group">
            <label>전화번호</label>
            <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="전화번호를 입력해주세요"
              required
            />
            <button type="button" onClick={sendVerificationCode}>
              인증번호 전송
            </button>
          </div>

          {/* 인증번호 입력 및 확인 */}
          {codeSent && (
            <div className="form-group">
              <label>인증번호</label>
              <input
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                placeholder="인증번호를 입력해주세요"
                required
              />
              <button type="button" onClick={verifyCode}>
                인증번호 확인
              </button>
            </div>
          )}

          {/* 아이디 찾기 버튼 */}
          <div className="button-container">
            <button type="submit" className="forgotId-button">
              아이디 찾기
            </button>
          </div>
        </form>

        {/* 모달 창 */}
        {showModal && (
          <Modal>
            <div className="modal-content">
              <h3>아이디 찾기 결과</h3>
              <p>{resultMessage}</p>
              <button onClick={closeModal}>닫기</button>
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
};

// 모달 컴포넌트
const Modal = ({ children }) => {
  return (
    <div className="modal-overlay">
      <div className="modal">{children}</div>
    </div>
  );
};

export default ForgotId;
